import { render, staticRenderFns } from "./IconSvgInstagram.vue?vue&type=template&id=ad76b9ba&scoped=true&"
import script from "./IconSvgInstagram.vue?vue&type=script&lang=js&"
export * from "./IconSvgInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad76b9ba",
  null
  
)

export default component.exports